<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <h4 class="mb-2">
          {{ $t("users.users") }}
        </h4>
        <div class="items" v-if="roles === null">
          <Skeletor v-for="i in 5" height="30" class="mb-1 btn" :key="i" />
        </div>
        <div class="items" v-else>
          <button
            v-on:click="
              active = 'users';
              selectedRole = null;
            "
            class="btn w-100 text-start"
            :class="
              active === 'users' && selectedRole === null
                ? 'btn-primary'
                : 'btn-simple'
            "
          >
            {{ $t("users.allUser") }}
          </button>
          <button
            class="btn w-100 text-start"
            v-on:click="
              active = 'users';
              selectedRole = role;
            "
            v-for="role in roles"
            :class="
              active === 'users' && selectedRole?.id === role.id
                ? 'btn-primary'
                : 'btn-simple'
            "
            :key="role.id"
          >
            {{ role.name }}
          </button>
        </div>
        <h4 class="my-2">
          {{ $t("users.groups") }}
        </h4>
        <div class="items" v-if="roles === null">
          <Skeletor v-for="i in 3" height="30" class="mb-1 btn" :key="i" />
        </div>
        <div class="items" v-else>
          <button
            class="btn w-100 text-start"
            v-for="role in roles"
            :key="role.id"
            :class="
              active === 'group' && selectedRole?.id === role.id
                ? 'btn-primary'
                : 'btn-simple'
            "
            v-on:click="editPermission(role)"
          >
            {{ role.name }}
          </button>
          <button class="btn w-100 text-start" v-on:click="newRole">
            {{ $t("users.createNew") }}
          </button>
        </div>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10">
      <div v-if="active === 'users'">
        <h2>
          {{ $t("users.usersAndGroups") }}
        </h2>
        <h4>
          {{ $t("users.users") }}
        </h4>
        <one-by-one-table
          v-model:rows="rows"
          :items="
            (users || []).filter(
              (e) => selectedRole === null || selectedRole.id === e.role_id
            )
          "
          type="users"
          v-on:addbtn="newUser"
          :show-edit="true"
          v-on:edit="editUser"
          v-on:delete="deleteUser"
        />
      </div>
      <div v-if="active === 'group'" class="permissions-page">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h2 class="mb-1">
              <b>{{ selectedRole.name }}</b>
              {{ $t("users.group") }}
            </h2>
            <span class="text-muted regular-14">
              {{ $t("users.privilegesAndAccessRights") }}
            </span>
          </div>
        </div>

        <div v-if="permissions === null">
          <div v-for="i in 10" :key="i" class="my-2 mx-1 row">
            <Skeletor size="20" class="col-auto me-2" />
            <Skeletor class="col-auto" :width="Math.random() * 50 + 20 + '%'" />
          </div>
        </div>

        <div v-else class="permission-groups">
          <div v-if="globalWildcard" class="mb-4">
            <div
              class="
                allow-all-row
                d-flex
                align-items-center
                px-3
                py-2
                border
                rounded
              "
            >
              <label
                class="
                  cstm-check
                  d-flex
                  align-items-center
                  gap-2
                  mb-0
                  flex-grow-1
                "
              >
                <input
                  type="checkbox"
                  :checked="enabledPermissions[globalWildcard.id]"
                  v-on:change="
                    changePermission(globalWildcard.id, $event.target.checked)
                  "
                />
                <span class="checkmark select"></span>
                <span class="fw-semibold small">{{ globalWildcard.name }}</span>
              </label>
              <span class="permission-method-badge badge badge-secondary"
                >rw</span
              >
            </div>
          </div>
          <div
            v-for="(category, catKey) in groupedPermissions"
            :key="catKey"
            class="mb-5"
          >
            <div
              class="
                d-flex
                align-items-center
                mb-3
                pb-2
                border-bottom
                cursor-pointer
              "
              v-on:click="toggleCategory(catKey)"
            >
              <span
                class="
                  category-badge
                  d-inline-flex
                  align-items-center
                  justify-content-center
                  rounded-circle
                  me-2
                "
                :class="'category-' + catKey"
                >{{ Number(catKey) + 1 }}</span
              >
              <h4 class="fw-bold mb-0">{{ category.label }}</h4>
              <span class="ms-auto category-toggle">{{
                collapsedCategories[catKey] ? "&#9660;" : "&#9650;"
              }}</span>
            </div>
            <template
              v-for="(group, groupKey) in category.groups"
              :key="groupKey"
            >
              <div
                class="permission-group mb-4"
                v-show="!collapsedCategories[catKey]"
              >
                <div
                  class="
                    permission-group-header
                    d-flex
                    align-items-center
                    justify-content-between
                    px-3
                    py-2
                    rounded-top
                    cursor-pointer
                  "
                  v-on:click="toggleGroup(groupKey)"
                >
                  <div class="d-flex align-items-center gap-2">
                    <h5 class="mb-0 fw-bold">{{ group.label }}</h5>
                    <span class="badge bg-secondary ms-2">{{
                      subGroupCount(group)
                    }}</span>
                  </div>
                  <span class="group-toggle">{{
                    collapsedGroups[groupKey] ? "&#9660;" : "&#9650;"
                  }}</span>
                </div>

                <div
                  v-if="!collapsedGroups[groupKey]"
                  class="permission-group-body border rounded-bottom p-0"
                >
                  <div
                    v-if="group.wildcardPerm"
                    class="
                      allow-all-row
                      d-flex
                      align-items-center
                      px-3
                      py-2
                      border-bottom
                    "
                  >
                    <label
                      class="
                        cstm-check
                        d-flex
                        align-items-center
                        gap-2
                        mb-0
                        flex-grow-1
                      "
                    >
                      <input
                        type="checkbox"
                        :checked="enabledPermissions[group.wildcardPerm.id]"
                        v-on:change="
                          changePermission(
                            group.wildcardPerm.id,
                            $event.target.checked
                          )
                        "
                      />
                      <span class="checkmark select"></span>
                      <span class="fw-semibold small">{{
                        group.wildcardPerm.name
                      }}</span>
                    </label>
                    <span class="permission-method-badge badge badge-secondary"
                      >rw</span
                    >
                  </div>
                  <div
                    v-else-if="group.wildcardRead || group.wildcardWrite"
                    class="
                      allow-all-row
                      d-flex
                      flex-column
                      gap-1
                      px-3
                      py-2
                      border-bottom
                    "
                  >
                    <label
                      v-if="group.wildcardRead"
                      class="cstm-check d-flex align-items-center gap-2 mb-0"
                    >
                      <input
                        type="checkbox"
                        :checked="enabledPermissions[group.wildcardRead.id]"
                        v-on:change="
                          changePermission(
                            group.wildcardRead.id,
                            $event.target.checked
                          )
                        "
                      />
                      <span class="checkmark select"></span>
                      <span class="fw-semibold small">{{
                        group.wildcardRead.name
                      }}</span>
                      <span
                        class="permission-method-badge badge badge-info ms-auto"
                        >read</span
                      >
                    </label>
                    <label
                      v-if="group.wildcardWrite"
                      class="cstm-check d-flex align-items-center gap-2 mb-0"
                    >
                      <input
                        type="checkbox"
                        :checked="enabledPermissions[group.wildcardWrite.id]"
                        v-on:change="
                          changePermission(
                            group.wildcardWrite.id,
                            $event.target.checked
                          )
                        "
                      />
                      <span class="checkmark select"></span>
                      <span class="fw-semibold small">{{
                        group.wildcardWrite.name
                      }}</span>
                      <span
                        class="
                          permission-method-badge
                          badge badge-warning
                          ms-auto
                        "
                        >write</span
                      >
                    </label>
                  </div>
                  <div v-if="group.rootPerms.length > 0">
                    <template
                      v-for="(perm, permIdx) in group.rootPerms"
                      :key="perm.id"
                    >
                      <div
                        class="
                          permission-row
                          d-flex
                          align-items-center
                          py-1
                          px-3
                        "
                        :class="[
                          permIdx % 2 === 0 ? 'bg-light' : '',
                          isCoveredByWildcard(perm, group)
                            ? 'permission-disabled'
                            : '',
                        ]"
                      >
                        <label
                          class="
                            cstm-check
                            d-flex
                            align-items-center
                            gap-2
                            flex-grow-1
                          "
                        >
                          <input
                            type="checkbox"
                            :checked="enabledPermissions[perm.id]"
                            :disabled="isCoveredByWildcard(perm, group)"
                            v-on:change="
                              changePermission(perm.id, $event.target.checked)
                            "
                          />
                          <span class="checkmark select"></span>
                          <span class="permission-name">{{ perm.name }}</span>
                        </label>
                        <span
                          class="permission-method-badge badge"
                          :class="
                            perm.id.endsWith('::read')
                              ? 'badge-info'
                              : perm.id.endsWith('::write')
                              ? 'badge-warning'
                              : 'badge-secondary'
                          "
                        >
                          {{
                            perm.id.endsWith("::read")
                              ? "read"
                              : perm.id.endsWith("::write")
                              ? "write"
                              : "rw"
                          }}
                        </span>
                      </div>
                    </template>
                  </div>
                  <div
                    v-for="(perms, subKey) in group.subGroups"
                    :key="subKey"
                    class="subgroup"
                  >
                    <div
                      class="
                        subgroup-header
                        d-flex
                        align-items-center
                        px-3
                        py-2
                        border-bottom
                      "
                    >
                      <span
                        class="
                          subgroup-label
                          small
                          fw-semibold
                          text-muted text-uppercase
                        "
                        >{{ subKey }}</span
                      >
                    </div>
                    <template v-for="(perm, permIdx) in perms" :key="perm.id">
                      <div
                        class="
                          permission-row
                          d-flex
                          align-items-center
                          py-1
                          px-3
                        "
                        :class="[
                          permIdx % 2 === 0 ? 'bg-light' : '',
                          isCoveredByWildcard(perm, group)
                            ? 'permission-disabled'
                            : '',
                        ]"
                      >
                        <label
                          class="
                            cstm-check
                            d-flex
                            align-items-center
                            gap-2
                            flex-grow-1
                          "
                        >
                          <input
                            type="checkbox"
                            :checked="enabledPermissions[perm.id]"
                            :disabled="isCoveredByWildcard(perm, group)"
                            v-on:change="
                              changePermission(perm.id, $event.target.checked)
                            "
                          />
                          <span class="checkmark select"></span>
                          <span class="permission-name">{{ perm.name }}</span>
                        </label>
                        <span
                          class="permission-method-badge badge"
                          :class="
                            perm.id.endsWith('::read')
                              ? 'badge-info'
                              : perm.id.endsWith('::write')
                              ? 'badge-warning'
                              : 'badge-secondary'
                          "
                        >
                          {{
                            perm.id.endsWith("::read")
                              ? "read"
                              : perm.id.endsWith("::write")
                              ? "write"
                              : "rw"
                          }}
                        </span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <EditUser
      ref="userModal"
      v-model:user="selectedUser"
      v-model:roles="roles"
      v-model:warehouses="warehouses"
      v-on:add="addUser"
    />
    <AddRole ref="roleModal" v-on:add="addRole" />
    <ConfirmModal
      ref="deleteModal"
      :title="$t(`users.deleteUser`)"
      text="<ul><li>You will delete<b> a user</b></li>
<li>You can't undo this action</li></ul><p>Are you sure you want to delete?</p>"
      cancel-button="No, Keep user"
      ok-button="Yes, delete user"
      v-on:success="deleteEvent"
    />
  </div>
</template>

<script>
import OneByOneTable from "../lists/OneByOneTable";
import { defineAsyncComponent } from "vue";
import http from "../../modules/http";
import EditUser from "../modals/EditUser";
import AddRole from "../modals/AddRole";
import { useStore } from "vuex";
import ConfirmModal from "../modals/ConfirmModal";

export default {
  name: "Users",
  components: { ConfirmModal, AddRole, EditUser, OneByOneTable },
  data() {
    return {
      store: useStore(),
      newUserModal: null,
      error: null,
      selectedUser: {},
      active: "users",
      selectedRole: null,
      rows: [
        {
          name: "Avatar",
          key: "avatar_url",
          type: "avatar",
          component: defineAsyncComponent(() =>
            import("../../components/lists/listItems/Avatar")
          ),
          editable: false,
          show: true,
        },
        {
          name: "Name",
          key: "full_name",
          type: "string",
          editable: false,
          show: true,
        },
        {
          name: "Email",
          key: "email",
          type: "string",
          editable: false,
          show: true,
        },
        {
          name: "Rank",
          key: "role_id",
          type: "enum",
          values: [],
          selectKey: "id",
          label: "name",
          skeletor: "rectangle",
          component: defineAsyncComponent(() =>
            import("../../components/lists/listItems/Tag")
          ),
          show: true,
        },
      ],
      deleteUserId: null,
      users: null,
      roles: null,
      enabledPermissions: null,
      permissions: null,
      permissionCategories: [],
      apps: {},
      collapsedGroups: {},
      collapsedCategories: {},
    };
  },
  computed: {
    warehouse() {
      return this.store.state.topBar.warehouse;
    },
    warehouses() {
      return this.store.state.warehouses;
    },
    q() {
      return this.store.state.topBar.q;
    },
    globalWildcard() {
      if (!this.permissions) return null;
      return this.permissions.find((p) => p.id === "*") || null;
    },
    groupedPermissions() {
      if (!this.permissions) return {};
      let groups = {};

      let filtered = this.permissions;
      if (this.q) {
        const q = this.q.toLowerCase();
        filtered = this.permissions.filter(
          (p) =>
            p.id.toLowerCase().includes(q) || p.name.toLowerCase().includes(q)
        );
      }
      filtered = filtered.filter((p) => p.id !== "*");

      for (const perm of filtered) {
        const isAppPerm = perm.app_id && this.apps[perm.app_id];
        const parts = perm.id.split("::");
        const isMethodSuffixed =
          parts.length >= 2 &&
          (parts[parts.length - 1] === "read" ||
            parts[parts.length - 1] === "write");
        const methodSuffix = isMethodSuffixed ? parts[parts.length - 1] : null;
        const cat = perm.category ?? 0;

        if (isAppPerm) {
          const app = this.apps[perm.app_id];
          const key = "app_" + app.id;
          if (!groups[key]) {
            groups[key] = {
              label: app.name || "App #" + app.id,
              rootPerms: [],
              subGroups: {},
              wildcardPerm: null,
              wildcardRead: null,
              wildcardWrite: null,
              category: 4,
            };
          }
          const subParts = parts.slice(2);
          if (subParts.length === 0) {
            groups[key].rootPerms.push(perm);
          } else if (subParts.length === 1 && subParts[0] === "*") {
            groups[key].wildcardPerm = perm;
          } else {
            const isMethodSuffixed2 =
              subParts.length >= 2 &&
              (subParts[subParts.length - 1] === "read" ||
                subParts[subParts.length - 1] === "write");
            const subKey2 = isMethodSuffixed2
              ? subParts.slice(0, -1)
              : subParts;
            if (subKey2.length === 1 && subKey2[0] === "*") {
              if (subParts[subParts.length - 1] === "read")
                groups[key].wildcardRead = perm;
              else if (subParts[subParts.length - 1] === "write")
                groups[key].wildcardWrite = perm;
            } else {
              const sk = subKey2.join("::");
              if (!groups[key].subGroups[sk]) groups[key].subGroups[sk] = [];
              groups[key].subGroups[sk].push(perm);
            }
          }
        } else {
          if (parts[0] === "*") continue;

          const ns = parts[0] || "other";
          const key = "ns_" + ns + "_cat" + cat;
          if (!groups[key]) {
            groups[key] = {
              label: ns.charAt(0).toUpperCase() + ns.slice(1),
              rootPerms: [],
              subGroups: {},
              wildcardPerm: null,
              wildcardRead: null,
              wildcardWrite: null,
              category: cat,
            };
          }

          const subParts = isMethodSuffixed
            ? parts.slice(1, -1)
            : parts.slice(1);

          if (subParts.length === 0) {
            groups[key].rootPerms.push(perm);
          } else if (subParts.length === 1 && subParts[0] === "*") {
            if (methodSuffix === "read") groups[key].wildcardRead = perm;
            else if (methodSuffix === "write") groups[key].wildcardWrite = perm;
            else groups[key].wildcardPerm = perm;
          } else {
            const subKey = subParts.join("::");
            if (!groups[key].subGroups[subKey])
              groups[key].subGroups[subKey] = [];
            groups[key].subGroups[subKey].push(perm);
          }
        }
      }

      for (const key of Object.keys(groups)) {
        const sorted = {};
        Object.keys(groups[key].subGroups)
          .sort()
          .forEach((k) => {
            sorted[k] = groups[key].subGroups[k];
          });
        groups[key].subGroups = sorted;
      }

      const cats = this.permissionCategories || {
        0: "General",
        1: "Functionality",
        2: "Settings",
        3: "Necessary",
        4: "Apps",
      };
      let byCategory = {};
      for (const catKey of Object.keys(cats)) {
        byCategory[catKey] = { label: cats[catKey], groups: {} };
      }
      const sortedGroupKeys = Object.keys(groups).sort();
      for (const key of sortedGroupKeys) {
        const group = groups[key];
        const cat = group.category ?? 0;
        if (byCategory[cat] !== undefined) {
          byCategory[cat].groups[key] = group;
        }
      }
      let result = {};
      Object.keys(byCategory)
        .sort()
        .forEach((k) => {
          result[k] = byCategory[k];
        });
      return result;
    },
  },
  beforeMount() {
    http
      .fetch("/users/roles")
      .then((data) => {
        this.roles = data;
      })
      .catch(() => {
        this.roles = [];
      });
    http
      .fetch("/users/")
      .then((data) => {
        this.users = data;
      })
      .catch(() => {
        this.users = [];
      });
  },
  methods: {
    toggleGroup(key) {
      this.collapsedGroups[key] = !this.collapsedGroups[key];
    },
    toggleCategory(key) {
      this.collapsedCategories[key] = !this.collapsedCategories[key];
    },
    subGroupCount(group) {
      return Object.keys(group.subGroups).length;
    },
    isCoveredByWildcard(perm, group) {
      if (perm.id === "*") return false;
      if (this.enabledPermissions["*"]) return true;
      if (group.wildcardPerm && this.enabledPermissions[group.wildcardPerm.id])
        return true;
      if (
        perm.id.endsWith("::read") &&
        group.wildcardRead &&
        this.enabledPermissions[group.wildcardRead.id]
      )
        return true;
      if (
        perm.id.endsWith("::write") &&
        group.wildcardWrite &&
        this.enabledPermissions[group.wildcardWrite.id]
      )
        return true;
      return false;
    },
    isReadWildcardEnabled(group) {
      if (this.enabledPermissions["*"]) return true;
      return (
        (group.wildcardPerm &&
          this.enabledPermissions[group.wildcardPerm.id]) ||
        (group.wildcardRead && this.enabledPermissions[group.wildcardRead.id])
      );
    },
    isWriteWildcardEnabled(group) {
      if (this.enabledPermissions["*"]) return true;
      return (
        (group.wildcardPerm &&
          this.enabledPermissions[group.wildcardPerm.id]) ||
        (group.wildcardWrite && this.enabledPermissions[group.wildcardWrite.id])
      );
    },
    toggleReadWildcard(group, checked) {
      if (group.wildcardPerm)
        this.changePermission(group.wildcardPerm.id, checked);
      else if (group.wildcardRead)
        this.changePermission(group.wildcardRead.id, checked);
    },
    toggleWriteWildcard(group, checked) {
      if (group.wildcardPerm)
        this.changePermission(group.wildcardPerm.id, checked);
      else if (group.wildcardWrite)
        this.changePermission(group.wildcardWrite.id, checked);
    },
    newUser() {
      this.$refs.userModal.showModal();
    },
    newRole() {
      this.$refs.roleModal.showModal();
    },
    addUser(data) {
      this.users.unshift(data);
    },
    addRole(data) {
      this.roles.unshift(data);
    },
    deleteUser(data) {
      this.deleteUserId = data.id;
      this.$refs.deleteModal.showModal();
    },
    deleteEvent() {
      http.fetch("/users/delete", { id: this.deleteUserId }, true);
    },
    editUser(id) {
      this.selectedUser = this.users.find((e) => e.id === id);
      this.$refs.userModal.showModal();
    },
    editPermission(role) {
      this.active = "group";
      this.selectedRole = role;
      this.getPermissions();
    },
    getPermissions() {
      http
        .fetch("/users/permissions?role=" + this.selectedRole.id)
        .then((data) => {
          this.enabledPermissions = data.enabled;
          this.permissions = data.permissions;
          this.permissionCategories = data.categories;
          this.apps = data.apps || {};
        })
        .catch(() => {
          this.enabledPermissions = [];
          this.permissions = [];
        });
    },
    changePermission(id, status) {
      let pr = {};
      pr[id] = status;
      this.enabledPermissions = { ...this.enabledPermissions, [id]: status };
      http.fetch(
        "/users/save-permissions",
        {
          permissions: pr,
          role: this.selectedRole.id,
        },
        true
      );
    },
  },
  watch: {
    roles() {
      this.rows[3].values = this.roles;
    },
  },
};
</script>

<style scoped>
.permission-group-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s;
}
.permission-group-header:hover {
  opacity: 0.9;
}
.group-icon {
  font-size: 1.2rem;
}
.group-toggle {
  font-size: 0.8rem;
  opacity: 0.8;
}
.permission-group-body {
  background: #fff;
  border-color: #dee2e6 !important;
}
.permission-row:hover {
  background: #f0f4ff !important;
}
.permission-name {
  font-size: 0.9rem;
  color: #333;
}
.permission-method-badge {
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.badge-info {
  background: #e3f2fd;
  color: #1565c0;
}
.badge-warning {
  background: #fff3e0;
  color: #e65100;
}
.badge-secondary {
  background: #e8eaf6;
  color: #3949ab;
}
.subgroup-header {
  background: #f8f9fa;
}
.subgroup-label {
  letter-spacing: 0.3px;
  min-width: 120px;
}
.subgroup + .subgroup .subgroup-header {
  border-top: 2px solid #e9ecef !important;
}
.allow-all-row {
  background: #eef2ff;
  border-bottom: 1px solid #dee2e6;
}
.permission-disabled {
  opacity: 0.4;
  pointer-events: none;
}
.permission-disabled .cstm-check input {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
  user-select: none;
}
.category-toggle {
  font-size: 0.8rem;
  opacity: 0.6;
}
.category-badge {
  width: 28px;
  height: 28px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}
.category-0 {
  background: #5c6bc0;
}
.category-1 {
  background: #43a047;
}
.category-2 {
  background: #fb8c00;
}
.category-3 {
  background: #8e24aa;
}
.category-4 {
  background: #00897b;
}
</style>
